export default "__VITE_ASSET__CfZMc6QF__"